<template>
    <div class="head">
        <div class="title">
          <div style="margin-left: 230px;">欢迎来到绍兴市阳光采购服务平台！</div>
          <!-- <div style="margin-right: 260px;">{{datestr}} {{weekstr}}  |  {{city}}  {{weather}}  {{temp}}℃</div> -->
          <div style="margin-right: 260px;">{{datestr}} {{weekstr}}</div>
          <!--   访问量：0 -->
        </div>
        <div style="width: 100%;width: 100%;display: flex;justify-content: space-between;">
          <div style="text-align: left;">
            <img  class="logo" src="../../assets/img/logo.png"/>
          </div>
          <div style="width:880px">
            <input type="text" class="search" v-model="keyword" @keyup.enter = "Query" />
            <button class="searchbot" @click="Query">
              <img src="../../assets/img/search.png" alt="">
              <!-- <img src="../../assets/img/character.png" alt=""> -->
            </button>
            <img style="width: 225px;position: absolute;right: 5px;top: 11px;" src="../../assets/img/characterC.png" alt="">
          </div>
        </div>
        <div class="menu">
            <ul>
            <li  @click="CheckNav('首页')" :class="NavName == '首页' ? 'z_a_selected' : ''">
              <router-link
                to="/home"
              >
                首 页
              </router-link>
            </li>
            <li @click="CheckNav('平台介绍')" :class="NavName == '平台介绍' ? 'z_a_selected' : ''">
              <router-link
                to="/list?type=0&class=1&categoryId=01"
              >
                平台介绍
              </router-link>
            </li>
            <li @click="CheckNav('通知动态')" :class="NavName == '通知动态' ? 'z_a_selected' : ''">
              <router-link
                to="/list?type=0&class=2&categoryId=02"
              >
                通知动态
              </router-link>
            </li>
            <li @click="CheckNav('交易信息')" :class="NavName == '交易信息' ? 'z_a_selected' : ''">
              <router-link
                to="/list?type=2&class=3&noticeType=21"
              >
                交易信息
              </router-link>
            </li>
            <!-- <li @click="CheckNav('非进场项目交易公告')" :class="NavName == '非进场项目交易公告' ? 'z_a_selected' : ''">
              <router-link style="line-height: 30px;margin-top: 10px;font-size: 18px;"
                to="/list?type=99&class=99&noticeType=001&InfoTypeId=001002001"
              >
              非进场项<br/>目交易公告
              </router-link>
            </li> -->
            <li @click="CheckNav('政策法规')" :class="NavName == '政策法规' ? 'z_a_selected' : ''">
              <router-link
                to="/list?type=0&class=4&categoryId=05"
              >
                政策法规
              </router-link>
            </li>
            <li @click="CheckNav('常见问题')" :class="NavName == '常见问题' ? 'z_a_selected' : ''">
              <router-link
                to="/list?type=0&class=5&categoryId=04"
              >
                常见问题
              </router-link>
            </li>
            <li @click="CheckNav('资料下载')" :class="NavName == '资料下载' ? 'z_a_selected' : ''">
              <router-link
                to="/list?type=0&class=6&categoryId=07"
              >
                资料下载
              </router-link>
            </li>
            <li @click="CheckNav('办事指南')" :class="NavName == '办事指南' ? 'z_a_selected' : ''">
              <router-link
                to="/list?type=0&class=7&categoryId=09"
              >
                办事指南
              </router-link>
            </li>
            <li @click="CheckNav('诚信专栏')" :class="NavName == '诚信专栏' ? 'z_a_selected' : ''">
              <router-link
                to="/list?type=3&class=8&categoryId=12"
              >
                诚信专栏
              </router-link>
            </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'home',
  data () {
    return {
      keyword: '',
      datestr: '',
      weekstr: '',
      city: '',
      temp: '',
      weather: ''
    }
  },
  computed: {
    NavName () {
      return this.$store.state.nav.navName
    }
  },
  methods: {
    ...mapMutations(['SET_NAV_NAME']),
    CheckNav (str) {
      this.SET_NAV_NAME(str)
    },
    Query () {
      this.$router.push({
        path: '/list',
        query: { type: 4, keyword: this.keyword }
      })
    },
    getNowDate () {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      let day = timeOne.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      this.datestr = `${year}年${month}月${day}日`
      var weeka = timeOne.getDay()
      var weekb = ''
      switch (weeka) {
        case 0:
          weekb = '日'
          break
        case 1:
          weekb = '一'
          break
        case 2:
          weekb = '二'
          break
        case 3:
          weekb = '三'
          break
        case 4:
          weekb = '四'
          break
        case 5:
          weekb = '五'
          break
        default:
          weekb = '六'
      }
      this.weekstr = '星期' + weekb
    }
  },
  created () {
    this.getNowDate()
    this.$http.get('https://apia.aidioute.cn/weather/index.php').then((res) => {
      console.log(res)
      this.city = res.data.data.location.city
      this.temp = res.data.data.weather.temp
      this.weather = res.data.data.weather.weather
      console.log('weather:' + this.weather)
    })
  }
}
</script>

<style>
.head{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalHeader/ZHeader.vue